import { render, staticRenderFns } from "./ServicePlaceHeader.vue?vue&type=template&id=6cf8b6bc&scoped=true&"
import script from "./ServicePlaceHeader.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8b6bc",
  null
  
)

export default component.exports